
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'เรื่องราว',
	'noDashboardFound': 'ไม่สามารถเรียกคืนเรื่องราวได้ เนื่องจากไม่มีข้อมูลอยู่แล้ว หรือคุณมี privileges ไม่เพียงพอในการดูข้อมูล',
	'noDashboardCapability': 'คุณไม่มีความสามารถในการใช้เรื่องราวได้',
	'noDashboardPermision': 'คุณมีสิทธิไม่เพียงในการดูเรื่องราวนี้',
	'defaultName': 'เรื่องใหม่',
	'storyProperties': 'คุณสมบัติของเรื่อง',
	'createAvDataStoryLabel': 'เรื่องราว',
	'createAvSlideShowLabel': 'สไลด์โชว์',
	'createAvPanAndZoomLabel': 'Guided journey',
	'dashboard_save_success': 'เรื่องราวของคุณถูกบันทึกแล้ว',
	'cmEmptySelection': 'เรื่องราวได้ถูกลบทิ้งแล้ว ลองบันทึกเป็นเรื่องราวใหม่',
	'createStoryTitle': 'สร้างเรื่องราว',
	'transitionStyleTitle': 'สไตล์การเปลี่ยนรูป',
	'createButton': 'สร้าง',
	'cancelButton': 'ยกเลิก',
	'dashboardResetTitle': 'รีเซ็ตเรื่องราว',
	'dashboardResetMessage': 'คุณแน่ใจว่าต้องการรีเซ็ตการเปลี่ยนแปลงทั้งหมดที่นำไปใช้กับเรื่องราวนี้หรือไม่?',
	'dashboardResetToast': 'เรื่องราวของคุณถูกรีเซ็ตแล้ว',
	'filter_drag_and_drop_all_tabs': 'ลากและปล่อยข้อมูลที่นี่เพื่อกรองฉากทั้งหมด',
	'filter_drag_and_drop_current_tab': 'ลากและปล่อยข้อมูลที่นี่เพื่อกรองฉากนี้',
	'filterIconLabel_Global': 'ฉากทั้งหมด',
	'filterIconLabel_Tab': 'ฉากนี้',
	'filterIconTooltip_Global': 'ฉากทั้งหมด',
	'filterIconTooltip_Tab': 'ฉากนี้',
	'filterOverflowMenu_Global': 'โอเวอร์โฟลว์เมนูซีนทั้งหมด',
	'filterOverflowMenu_Tab': 'โอเวอร์โฟลว์เมนูซีนนี้',
	'renameScene': 'เปลี่ยนชื่อฉาก',
	'duplicateScene': 'ทำซ้ำฉาก',
	'deleteScene': 'ลบฉาก',
	'editTimelineHighlight': 'แก้ไขไฮไลต์',
	'deleteTimelineHighlight': 'ลบไฮไลต์',
	'filter_includesAll': 'รวมทั้งหมด',
	'timeline_highlight_moved_to': 'ไฮไลต์ไทม์ไลน์ %{id} ถูกย้ายไปยัง %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'เลือก',
	'newDefaultStoryName': 'เรื่องราว: %{modelName}',
	'exportLabel': 'บันทึก',
	'exportAsLabel': 'บันทึกเป็น:',
	'exportDialogTitle': 'บันทึกเป็นเรื่องราว',
	'exportDialogFooter': 'ปุ่มบันทึกและยกเลิก',
	'loadAfterExportLabel': 'เปิดเรื่องราวหลังการบันทึก',
	'selectTemplateLabel': 'เลือกเท็มเพลต',
	'outOfBoundsWarningMessage': 'วิดเจ็ตแดชบอร์ดบางตัวอยู่นอกกริดและอาจไม่แสดงผลอย่างถูกต้องหลังการเอ็กซ์พอร์ต',
	'emptyExploreCardsWarningMessage': 'การ์ดเปล่าถูกลบทิ้งในระหว่างที่บันทึกเป็นเรื่องราว',
	'dashboard_export_success': 'แดชบอร์ดของคุณถูกบันทึกเป็นเรื่องราวเรียบร้อยแล้ว',
	'explore_export_success': 'การสำรวจของคุณถูกบันทึกเป็นเรื่องราวเรียบร้อยแล้ว',
	'toastUpgradeDone': 'เรื่องราวของคุณถูกอัพเกรดแล้ว บันทึกเดี๋ยวนี้เพื่อรักษาประสิทธิภาพสูงสุด',
	'navigationMarker': 'ตัวทำเครื่องหมายการนำทาง',
	'navigateMarkers': 'นำทางตัวทำเครื่องหมาย',
	'navNextMarker': 'ตัวทำเครื่องหมายถัดไป',
	'navPrevMarker': 'ตัวทำเครื่องหมายก่อนหน้า',
	'navPrevMarkerAbbreviated': 'ตัวทำเครื่องหมายก่อนหน้า',
	'timelineSettingsButton': 'อ็อพชันการเล่นกลับ',
	'autoPlay': 'เล่นฉากทั้งหมด',
	'loop': 'ลูป',
	'refreshData': 'รีเฟรชเพื่อเริ่ม',
	'slideshowLabel': 'สไลด์โชว์',
	'panAndZoomLabel': 'Guided journey',
	'slideShowLayoutLabel': 'โครงร่างแบบสไลด์โชว์',
	'panAndZoomLayoutLabel': 'โครงร่าง Guided journey',
	'panAndZoomLayoutFooter': 'โครงร่าง guided journey เป็นคอลเล็กชันของฉากบนหนึ่งภาพวาด เมื่อคุณรันเรื่องชนิดนี้ การซูมและแพนการนำเสนอบนแต่ละฉากตามลำดับ สิ่งนี้แตกต่างจากโครงร่าง สไลด์โชว์ที่แต่ละฉากแสดงอยู่บนภาพวาดใหม่ โครงร่าง guided journey ที่มีฉากสามฉากเชื่อมต่อด้วยบรรทัดที่คุณสามารถสร้างลำดับของฉากในแนวนอนได้ สิ่งนี้มีประโยชน์สำหรับการแสดงเส้นเวลา',
	'PanAndZoomLayout1': '5 ฉากที่จัดเรียงในรูปสี่เหลี่ยมผืนผ้า',
	'PanAndZoomLayout2': '4 ฉากที่จัดเรียงในรูปแบบขั้นบันไดจากซ้ายไปขวา',
	'PanAndZoomLayout3': '6 ฉากที่จัดเรียงในรูปสี่เหลี่ยมผืนผ้า',
	'PanAndZoomLayout4': '7 ฉากที่จัดเรียงในรูปสี่เหลี่ยมผืนผ้า ที่มีฉากขนาดเล็ก 6 ฉากที่ด้านบนและ 1 ฉากขนาดใหญ่ที่ด้านล่าง',
	'PanAndZoomLayout5': '3 ฉากที่จัดเรียงในรูปสี่เหลี่ยมผืนผ้า ที่มีฉากขนาดเล็ก 2 ฉากที่ด้านบนและ 1 ฉากขนาดใหญ่ที่ด้านล่าง',
	'PanAndZoomLayout6': 'ลำดับของ 4 ฉากที่จัดเรียงตามแนวนอน',
	'pageSelectWarning': 'โปรดเลือกฉาก',
	'noSceneTransitionLabel': 'ไม่มีอยู่',
	'sceneTransitionPropertyLabel': 'การเปลี่ยนฉาก',
	'animatedPathSceneTransitionLabel': 'พาธเคลื่อนไหว',
	'sweepSceneTransitionLabel': 'ปัด',
	'storyTypeLabel': 'ชนิดของเรื่องราว',
	'layoutLabel': 'โครงร่าง',
	'tabName_animation': 'แอนิเมชัน',
	'propAniAnimation': 'แอนิเมชัน',
	'propAniTypeEntrance': 'แอนิเมชันทางเข้า',
	'propAniDirectionIn': 'ทิศทางของทางเข้า',
	'propAniTypeExit': 'แอนิเมชันทางออก',
	'propAniDirectionOut': 'ทิศทางของทางออก',
	'propAniDirection': 'ทิศทาง',
	'propAniEntrance': 'ทางเข้า',
	'propAniTypeEntranceSlideIn': 'เลื่อนเข้าข้างใน',
	'propAniTypeEntranceFadeIn': 'ทำให้ภาพชัดขึ้น',
	'propAniTypeEntrancePivotIn': 'หมุนเข้า',
	'propAniTypeEntranceScaleIn': 'ขยายสเกล',
	'propAniTypeEntranceShrinkIn': 'หด',
	'propAniDirectionInLeft': 'จากด้านซ้าย',
	'propAniDirectionInRight': 'จากด้านขวา',
	'propAniDirectionInTop': 'จากด้านบน',
	'propAniDirectionInBottom': 'จากด้านล่าง',
	'propAniExit': 'ออกจากโปรแกรม',
	'propAniTypeExitSlideIn': 'เลื่อนออก',
	'propAniTypeExitFadeIn': 'ทำให้ภาพมัวลง',
	'propAniTypeExitPivotOut': 'หมุนออก',
	'propAniTypeExitScaleIn': 'ย่อสเกล',
	'propAniTypeExitExpandOut': 'ขยายออก',
	'propAniDirectionOutLeft': 'ทางด้านซ้าย',
	'propAniDirectionOutRight': 'ทางด้านขวา',
	'propAniDirectionOutTop': 'ไปด้านบน',
	'propAniDirectionOutBottom': 'ลงไปด้านล่าง',
	'propAniEntranceTime': 'เริ่มเมื่อ (วินาที):',
	'propAniExitTime': 'สิ้นสุดเมื่อ (วินาที):',
	'animationNoEntranceText': 'ภาพเคลื่อนไหว Entrance จะไม่แสดงหากวิดเจ็ตอยู่ที่เริ่มต้นของฉาก',
	'animationNoExitText': 'ภาพเคลื่อนไหว Exit จะไม่แสดงหากวิดเจ็ตอยู่ที่ท้ายของฉาก',
	'propAniTypeDataEntrance': 'ทางเข้าของข้อมูล',
	'propAniRevealDuration': 'ระยะเวลาภาพเคลื่อนไหวเริ่มต้น',
	'timelineAnimationProperties': 'เปิดคุณสมบัติภาพเคลื่อนไหว',
	'scenesPropertiesSection': 'ฉาก',
	'editStoryCoachMarkTitle': 'แก้ไขเรื่อง',
	'editStoryCoachMarkContents': 'คลิกที่ไอคอนรูปดินสอเพื่อแก้ไขเรื่องนี้',
	'addDataStoryCoachMarkContents': 'ลากและปล่อยจากพาเนลข้อมูลลงบนเรื่องของคุณ',
	'expandSceneCoachmarkTitle': 'เปิดไทม์ไลน์',
	'expandSceneCoachmarkContents': 'แสดงภาพเคลื่อนไหวของฉากโดยการปรับการแสดงอ็อบเจ็กต์ตามเวลาและระยะเวลา',
	'overviewCoachmarkTitle': 'ฉากภาพรวม',
	'overviewCoachmarkContents': 'ใช้ฉากภาพรวมที่จุดเริ่มต้นและจุดสิ้นสุดของเรื่องเพื่อแสดงภาพใหญ่ของฉากทั้งหมด จากฉากภาพรวม คลิกและลากฉากเพื่อปัดไปเป็นฉากอื่น คุณสามารถแสดงหรือซ่อนฉากภาพรวมในคุณสมบัติเรื่อง',
	'animatedPathCoachmarkTitle': 'พาธเคลื่อนไหว',
	'animatedPathCoachmarkContents': 'เมื่อต้องการทำให้อ็อบเจ็กต์เคลื่อนไหวจากฉากหนึ่งไปยังอีกฉากหนึ่ง ให้ทำซ้ำฉากด้วยอ็อบเจ็กต์ จากนั้น ย้าย ปรับขนาด หรือหมุนอ็อบเจ็กต์ที่ทำซ้ำบนฉากใหม่',
	'propShowStoryOverviewFirstSlide': 'แสดงทุกฉากตอนเริ่มต้น',
	'propShowStoryOverviewLastSlide': 'แสดงทุกฉากตอนจบ',
	'storySceneSingleCountLabel': '1 ฉาก',
	'storySceneCountLabel': '%{count} ฉาก',
	'storySceneRangeCountLabel': 'ฉาก %{index} จาก %{count}',
	'storySceneExpand': 'เปิดไทม์ไลน์',
	'storySceneActionMenu': 'เมนูอ็อพชันเรียกใช้ฉาก',
	'timelineRightContainerLabel': 'กลุ่มของตัวควบคุมปุ่มเส้นเวลา',
	'timelineViewLabel': 'เส้นเวลา',
	'timelineZoomFit': 'ขยายเพื่อให้พอดี',
	'timelineZoomIn': 'ขยาย',
	'timelineZoomOut': 'ย่อ',
	'timelinePositionIndicator': 'ตัวบ่งชี้ตำแหน่งไทม์ไลน์ที่ %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'ตัวบ่งชี้ตำแหน่งไทม์ไลน์ย้ายจากทางซ้ายไป %{position}',
	'timelinePositionIndicatorMoveRightTo': 'ตัวบ่งชี้ตำแหน่งไทม์ไลน์ย้ายจากทางขวาไป %{position}',
	'sceneStart': 'ข้ามไปยังจุดเริ่มต้นของฉากที่ %{position}',
	'sceneEnd': 'ข้ามไปยังท้ายของฉากที่ %{position}',
	'timelineHighlightTitle': 'ไฮไลต์',
	'addTimelineHighlight': 'เพิ่มไฮไลต์',
	'addSceneBtnTitle': 'เพิ่มฉากใหม่ที่มีเท็มเพลตดีฟอลต์',
	'addSceneChevronBtnTitle': 'เลือกเท็มเพลตฉาก',
	'timelinePlay': 'เล่น',
	'timelinePause': 'หยุดชั่วคราว',
	'sceneNavigation': 'การนำทางฉาก',
	'navNextScene': 'ฉากถัดไป',
	'navPrevScene': 'ฉากก่อนหน้านี้',
	'navPrevSceneAbbreviated': 'ฉากก่อนหน้านี้',
	'navExitFullScreen': 'ออกจากการแสดงแบบเต็มหน้าจอ',
	'navToggleOverview': 'สลับภาพรวม',
	'rowNumber': 'แถว %{number}',
	'overviewBtnLabel': 'ภาพรวม',
	'sceneListStart': 'เริ่มต้นภาพรวม',
	'sceneListEnd': 'สิ้นสุดภาพรวม',
	'timelineLeftHandle': 'ที่จับด้านซ้ายสำหรับ %{name}',
	'timelineRightHandle': 'ที่จับด้านขวาสำหรับ %{name}',
	'timelineLeftHandleNoTitle': 'ที่จับด้านซ้าย',
	'timelineRightHandleNoTitle': 'ที่จับด้านขวา',
	'timelineMoveLeft': 'ย้าย %{object} ไปทางซ้าย',
	'timelineMoveRight': 'ย้าย %{object} ไปทางขวา',
	'timelineMoveWidget': 'วิดเจ็ต time line ถูกย้ายไปยัง %{newStartTime} และ %{newEndTime}',
	'timelineMoveWidgetStartTime': 'เวลาเริ่มต้นของวิดเจ็ต time line ถูกเปลี่ยนเป็น %{newStartTime}',
	'timelineMoveWidgetEndTime': 'เวลาสิ่นสุดของวิดเจ็ต time line ถูกเปลี่ยนเป็น %{newEndTime}',
	'timelineMoveWidgetDown': 'วิดเจ็ต time line ถูกเลื่อนลง',
	'timelineMoveWidgetUp': 'วิดเจ็ต time line ถูกเลื่อนขึ้น',
	'addSceneTitle': 'เพิ่มฉาก',
	'blankSceneLayout': 'ว่าง',
	'titleSceneLayout': 'หัวเรื่องที่มีคำบรรยาย',
	'sceneLayout1': 'หัวเรื่องที่มีข้อความพร้อมกับวิชวลไลเซชันหนึ่งรายการ',
	'sceneLayout2': 'หัวเรื่องที่มีวิชวลไลเซชันหนึ่งรายการ',
	'sceneLayout3': 'หัวเรื่องที่มีวิชวลไลเซชันสองรายการ',
	'sceneLayout4': 'เอนกประสงค์',
	'sceneLayout5': 'ไม่มีหัวเรื่องที่มีข้อความพร้อมกับวิชวลไลเซชันหนึ่งรายการ',
	'sceneLayout6': 'เอนกประสงค์ 2 คูณ 2',
	'sceneLayout7': 'เอนกประสงค์ 2 เทียบกับ 1',
	'sceneLayout8': 'เอนกประสงค์ 1 เทียบกับ 2',
	'sceneLayout9': 'เอนกประสงค์ 1 เหนือ 2',
	'sceneLayout10': 'เอนกประสงค์ 2 เหนือ 1',
	'sceneLayout11': 'เอนกประสงค์ 4 เหนือ 1',
	'sceneLayout12': 'เอนกประสงค์ 1 เหนือ 1 เทียบกับ 2 คูณ 2 เหนือ 1',
	'titleWidgetPlaceholderText': 'ป้อนหัวเรื่องของคุณที่นี่',
	'subtitleWidgetPlaceholderText': 'ป้อนหัวเรื่องย่อยของคุณที่นี่',
	'createStoryViewTitle': 'สร้างเรื่อง',
	'defaultStoryName': 'เรื่องใหม่',
	'screenshot_label': 'เรื่องราว %{title}',
	'screenshot_label_scene': 'ฉาก %{sceneTitle} ของเรื่องราว %{title}',
	'filmstripHandleOpenLabel': 'เปิดตัวเลือกฉาก',
	'filmstripHandleCloseLabel': 'ปิดตัวเลือกฉาก'
});
